module.exports = __webpack_public_path__ + "media/images/powerpullup-7f9fffab56da7133d671344f8792a528.png";